import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import * as Constant from '../../../constants/actionTypes';
import { labelName } from '../../UtilsWeb';
import styles from './styles';

class CardTemplate extends PureComponent {
  loadCardTemplate = groupMember => {
    const { locale } = this.props;
    const { Member, MemberShip } = { ...groupMember };
    const { TemplateName } = { ...MemberShip[0] };

    let Component = null;
    if (MemberShip) {
      switch (TemplateName) {
        case Constant.DIGITAL_CARD_ARKANSAS_ADULT:
        case Constant.DIGITAL_CARD_ARKANSAS_KIDS:
        case Constant.DIGITAL_CARD_AR_CARD_TEMPLATE: // AR client required this Template
          Component = require('./ArkansasAdult').default;
          break;
        default:
          Component = require('./ArkansasAdult').default;
      }
    }
    if (Component) {
      return <Component locale={locale} User={Member} UserMemberShip={MemberShip} />;
    }
    return null;
  };

  checkValidity = Status => {
    const { classes } = this.props;
    if (Status === 'i' || Status === 'I') {
      return (
        <p className={classes.ErrorMessage1}>
          {labelName(Constant.LABEL_MEDICAID_ID_STATUS_NOT_VALID)}
        </p>
      );
    }
    return null;
  };

  render() {
    const {
      groupMember,
      groupMember: { MemberShip },
      classes,
    } = this.props;

    return (
      <div className={classes.CarouselWrapper}>
        {this.checkValidity(MemberShip[0].Status)}
        {this.loadCardTemplate(groupMember)}
      </div>
    );
  }
}

CardTemplate.propTypes = {
  groupMember: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
};

export default withStyles(styles)(CardTemplate);
